import React, { useState, useRef, useEffect } from "react";
import { Form, Container, Button, Row, Col } from "react-bootstrap";
import { useAuth } from "../AuthContext";
import { partidaApi } from "../api/partidaApi";
import Swal from "sweetalert2";

const AdaugPartida = ({ tema }) => {
  const { user } = useAuth();
  const isAdmin = user?.rol === "administrator";
  const ref = useRef();
  const [fond, setFond] = useState("");
  const [sumal, setSumal] = useState("");
  const [ocol, setOcol] = useState("");
  const [up, setUp] = useState("");
  const [ua, setUa] = useState("");
  const [suprafata, setSuprafata] = useState("");
  const [natura, setNatura] = useState("");
  const [taiere, setTaiere] = useState("");
  const [volBrut, setVolBrut] = useState("");
  const [volBrutComercial, setVolBrutComercial] = useState("");
  const [volMedRas, setVolMedRas] = useState("");
  const [volMedDt, setVolMedDt] = useState("");
  const [volMedDm, setVolMedDm] = useState("");
  const [panta, setPanta] = useState("");
  const [distColectare, setDistColectare] = useState("");
  const [stoc, setStoc] = useState("nu");
  const [valTotal, setvalTotal] = useState("");
  const [termenIncI, setTermenIncI] = useState("");
  const [termenSfI, setTermenSfI] = useState("");
  const [termenIncII, setTermenIncII] = useState("");
  const [termenSfII, setTermenSfII] = useState("");
  const [termMax, setTermMax] = useState("");
  const [transport, setTransport] = useState("");
  const [nrProcedura, setNrProcedura] = useState("");
  

const optiuniLucrari = {
  "Principale codru": [
    "Rase pe parchete mici",
    "Rase in benzi",
    "Succesive in margine de masiv",
    "Succesive 1",
    "Succesive 2",
    "Succesive 3",
    "Succesive 4",
    "Succesive definitive",
    "Progresive in margine de masiv",
    "Progresive 1",
    "Progresive 2",
    "Progresive 3",
    "Progresive 4",
    "Progresive - Racordare",
    "Cvasigradinarite 1",
    "Cvasigradinarite 2",
    "Cvasigradinarite 3",
    "Cvasigradinarite 4",
    "Cvasigradinarite 5",
    "Cvasigradinarite 6",
    "Cvasigradinarite definitive",
    "Gradinarite",  
    "Transformare spre Gradinarit"
  ],
  "Principale crâng": [
    "Crang Simplu",
    "Crang - Cazanire",
    "Crang -Scaun"
  ],
  "Principale Substituiri": ["De refacere",
    "De substituire"
  ],
  "Tăieri de conservare": [
    "Tăieri de conservare"],

  "Doborârturi I":["Tăieri de accidentale"],
  "Secundare Rărituri": [
    "De îngrijire",
  ],
"Accidentale I":[
    "Tăieri de accidentale I",
  ],

"Accidentale II":[
    "Tăieri de accidentale II",
  ],
"Doborârturi II":["Tăieri de accidentale II"],
"Igienă":[
  "Igienizarea pădurii",
],
"Doborâturi în masă I":[
  "Doborâturi în masă I",
],
"Doborâturi în masă II":[
  "Doborâturi în masă II",
],

};

useEffect(() => {
  if (user) {

    if (user.rol !== "administrator" && user.ocol) {
      setOcol(user.ocol);
    }
  }
}, [user]);

  
  const valoareGarantie = valTotal  ? ( parseFloat(valTotal) * 0.01).toFixed(2) : "";
  const valTarifBrut = valTotal && volBrut ? (parseFloat(valTotal) / parseFloat(volBrut)).toFixed(2) : "";
  const valTarifBrutCom = valTotal && volBrutComercial ? (parseFloat(valTotal) / parseFloat(volBrutComercial)).toFixed(2) : "";  

  
  const tratezSubmit = async (evt) => {
    evt.preventDefault();

    // 1. Stabilim ocolul corect
    // Folosim user?.ocol dacă nu este admin
   const ocolFinal = user?.rol === "administrator" ? ocol : user?.ocol;

    // 2. Colectăm datele într-un obiect
    const datePartida = {
      fond,
      sumal,
      up,
      ua,
      natura,
      taiere,
      stoc,
      transport,
      nrProcedura,
      ocol: ocolFinal,
      suprafata: parseFloat(suprafata) || 0,
      volBrut: parseFloat(volBrut) || 0,
      volBrutComercial: parseFloat(volBrutComercial) || 0,
      volMedRas: parseFloat(volMedRas) || 0,
      volMedDt: parseFloat(volMedDt) || 0,
      volMedDm: parseFloat(volMedDm) || 0,
      panta: parseFloat(panta) || 0,
      distColectare: parseFloat(distColectare) || 0,
      tarifBrut: parseFloat(valTarifBrut) || 0,
      tarifBrutCom: parseFloat(valTarifBrutCom) || 0,
      valTotal: parseFloat(valTotal) || 0,
      garantie: parseFloat(valoareGarantie) || 0,
      termenIncI,
      termenSfI,
      termenIncII,
      termenSfII,
      termMax: parseFloat(termMax) || 0,
      stare: "disponibil",
    };

    // 3. Validare rapidă cu SweetAlert
    const campuriObligatorii = [
      "fond",
      "sumal",
      "ocol",
      "up",
      "ua",
      "natura",
      "volBrut",
      "valTotal",
    ];
    const lipsescDate = campuriObligatorii.some((key) => !datePartida[key]);

    if (lipsescDate) {
      Swal.fire({
        icon: "warning",
        title: "Atenție!",
        text: "Te rugăm să completezi toate câmpurile obligatorii!",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    try {
      if (!partidaApi) {
        throw new Error("Serviciul API nu a fost încărcat corect.");
      }

      const result = await partidaApi.add(datePartida, user);

      // Mesaj de succes
      await Swal.fire({
        icon: "success",
        title: "Succes!",
        text: result.message || "Partida a fost salvată cu succes.",
        timer: 3000,
        showConfirmButton: true,
        confirmButtonColor: "#28a745",
      });

      // Resetare Formular
      resetareFormular();
    } catch (error) {
      console.error("Eroare la salvare:", error);

      // Mesaj de eroare
      Swal.fire({
        icon: "error",
        title: "Eroare la salvare",
        text:
          error.message || "A apărut o problemă la comunicarea cu serverul.",
        confirmButtonColor: "#d33",
      });
    }
  };

  const resetareFormular = () => {
    const setters = [
      setFond,
      setSumal,
      setUp,
      setUa,
      setSuprafata,
      setNatura,
      setTaiere,
      setVolBrut,
      setVolBrutComercial,
      setVolMedRas,
      setVolMedDt,
      setVolMedDm,
      setPanta,
      setvalTotal,
      setTermenIncI,
      setTermenSfI,
      setTermenIncII,
      setTermenSfII,
      setTermMax,
      setTransport,
      setNrProcedura,
    ];


    setters.forEach((s) => s(""));
    setDistColectare("");
    setStoc("nu");

    if (isAdmin) setOcol("");

    if (ref.current) ref.current.value = "";
  };

 

  const stil = {
    marginTop: "2rem",
    backgroundColor: tema === "dark" ? "#2b3035" : "#f8f9fa",
    color: tema === "dark" ? "#ffffff" : "#212529",
    padding: "20px",
    borderRadius: "8px",
    boxShadow:
      tema === "dark"
        ? "0 4px 12px rgba(0,0,0,0.5)"
        : "0 4px 8px rgba(0,0,0,0.1)",
    border: tema === "dark" ? "1px solid #495057" : "none",
  };

  return (
    <Container style={stil}>
      <h4 className="mb-1 text-center">Adaugă partida</h4>

      <Form onSubmit={tratezSubmit}>
        <div className="d-flex align-items-center my-3">
          <span
            className="text-info fw-bold text-uppercase me-2"
            style={{ letterSpacing: "1px", whiteSpace: "nowrap" }}
          >
            Detalii partida
          </span>
          <div className="flex-grow-1 border-bottom "></div>
        </div>

        {/* --- Rândul 1: Identificare de bază --- */}
        <Row>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Nr. Procedură:</Form.Label>
              <Form.Control
                type="text"
                value={nrProcedura}
                onChange={(e) => setNrProcedura(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Ocol Silvic:</Form.Label>
              <Form.Select
                value={ocol}
                onChange={(e) => setOcol(e.target.value)}
                disabled={user?.rol !== "administrator"}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege Ocolul...</option>
                <option value="Ludus">Ludus</option>
                <option value="Targu Mures">Târgu Mureș</option>
                <option value="Reghin">Reghin</option>
                <option value="Gurghiu">Gurghiu</option>
                <option value="Fancel">Fancel</option>
                <option value="Rastolita">Rastolita</option>
                <option value="Lunca Bradului">Lunca Bradului</option>
                <option value="Sovata">Sovata</option>
                <option value="Tarnaveni">Tarnaveni</option>
                <option value="Sighisoara">Sighisoara</option>
              </Form.Select>
              {user?.rol !== "administrator" && user?.ocol && (
                <Form.Text className="text-info">
                  Restricționat la ocolul dumneavoastră:{" "}
                  <strong>{user.ocol}</strong>
                </Form.Text>
              )}
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Nr. Fond:</Form.Label>
              <Form.Control
                type="text"
                value={fond}
                onChange={(e) => setFond(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Nr. SUMAL:</Form.Label>
              <Form.Control
                type="text"
                value={sumal}
                onChange={(e) => setSumal(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={1}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">UP:</Form.Label>
              <Form.Control
                type="text"
                value={up}
                onChange={(e) => setUp(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={1}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">UA:</Form.Label>
              <Form.Control
                type="text"
                value={ua}
                onChange={(e) => setUa(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
        </Row>

        {/* --- Rândul 2: Localizare --- */}
        <Row>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Natura produs:
              </Form.Label>
              <Form.Select
                value={natura}
                onChange={(e) => {
                  setNatura(e.target.value);
                  setTaiere(""); // Resetăm subcategoria când se schimbă categoria
                }}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege categoria...</option>
                {Object.keys(optiuniLucrari).map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          {/* Subcategoria Dinamică */}
          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Natura tăierii:
              </Form.Label>
              <Form.Select
                value={taiere}
                disabled={!natura} // Blocăm dacă nu avem categorie selectată
                onChange={(e) => setTaiere(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege natura lucrării...</option>
                {natura &&
                  optiuniLucrari[natura].map((sub) => (
                    <option key={sub} value={sub}>
                      {sub}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Suprafață (ha):</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={suprafata}
                onChange={(e) => setSuprafata(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Pantă (%):</Form.Label>
              <Form.Control
                type="number"
                step="0.1"
                value={panta}
                onChange={(e) => setPanta(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold small">
                Dist. Colectare:
              </Form.Label>
              <Form.Select
                value={distColectare}
                onChange={(e) => setDistColectare(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege distanța...</option>
                <option value="0-250">0-250 m</option>
                <option value="251-500">251-500 m</option>
                <option value="501-1000">501-1000 m</option>
                <option value="1001-1500">1001-1500 m</option>
                <option value="> 1500">Peste 1500 m</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={1}>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold small">Stoc:</Form.Label>
              <Form.Select
                value={stoc}
                onChange={(e) => setStoc(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="da">DA</option>
                <option value="nu">NU</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex align-items-center my-3">
          <span
            className="text-info fw-bold text-uppercase me-3"
            style={{ letterSpacing: "1px", whiteSpace: "nowrap" }}
          >
            Volume și Date Tehnice
          </span>
          <div className="flex-grow-1 border-bottom "></div>
        </div>

        {/* --- Rândul 3: Date Tehnice și Volume Brute --- */}
        <Row>
          <Col md={2}>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold small">
                Volum Brut (mc):
              </Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={volBrut}
                onChange={(e) => setVolBrut(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold small">
                Vol. Brut Comerciabil:
              </Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={volBrutComercial}
                onChange={(e) => setVolBrutComercial(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Vol. Med. Rășinoase:
              </Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={volMedRas}
                onChange={(e) => setVolMedRas(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Vol. Med. F. Tari:
              </Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={volMedDt}
                onChange={(e) => setVolMedDt(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Vol. Med. F. Moi:
              </Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                value={volMedDm}
                onChange={(e) => setVolMedDm(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex align-items-center my-3">
          <span
            className="text-info fw-bold text-uppercase me-3"
            style={{ letterSpacing: "1px", whiteSpace: "nowrap" }}
          >
            Valori și Garanții
          </span>
          <div className="flex-grow-1 border-bottom "></div>
        </div>

        {/* --- Rândul 5: Valori și Garanții --- */}
        <Row>
          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Valoare Totală (RON):
              </Form.Label>
              <Form.Control
                type="number"
                value={valTotal}
                onChange={(e) => setvalTotal(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Tarif Brut:</Form.Label>
              <Form.Control
                type="number"
                disabled
                value={valTarifBrut}
                className={
                  tema === "dark"
                    ? "bg-dark text-white border-secondary"
                    : "bg-light"
                }
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Tarif Brut Com.:
              </Form.Label>
              <Form.Control
                type="number"
                disabled
                value={valTarifBrutCom}
                className={
                  tema === "dark"
                    ? "bg-dark text-white border-secondary"
                    : "bg-light"
                }
              />
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Garanție (RON):</Form.Label>
              <Form.Control
                type="number"
                disabled
                value={valoareGarantie}
                className={
                  tema === "dark"
                    ? "bg-dark text-white border-secondary"
                    : "bg-light"
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="d-flex align-items-center my-3">
          <span
            className="text-info fw-bold text-uppercase me-2"
            style={{ letterSpacing: "1px", whiteSpace: "nowrap" }}
          >
            Detalii termene și transport
          </span>
          <div className="flex-grow-1 border-bottom "></div>
        </div>
        {/* --- Rândul 6: Termene și Transport --- */}
        <Row>
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Termen inc I:</Form.Label>
              <Form.Control
                type="date"
                value={termenIncI}
                onChange={(e) => setTermenIncI(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Termen Sf. I:</Form.Label>
              <Form.Control
                type="date"
                value={termenSfI}
                // Nu poți alege un sfârșit înainte de începutul primului termen
                min={termenIncI}
                onChange={(e) => setTermenSfI(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Termen inc II:</Form.Label>
              <Form.Control
                type="date"
                value={termenIncII}
                // Termenul II nu poate începe înainte să se termine Termenul I
                min={termenSfI}
                onChange={(e) => setTermenIncII(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Termen Sf. II:</Form.Label>
              <Form.Control
                type="date"
                value={termenSfII}
                // Sfârșitul II nu poate fi înainte de începutul II
                min={termenIncII}
                onChange={(e) => setTermenSfII(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>

          {/* Restul coloanelor rămân neschimbate */}
          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">
                Termen Max (1540):
              </Form.Label>
              <Form.Control
                type="number"
                value={termMax}
                onChange={(e) => setTermMax(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              />
            </Form.Group>
          </Col>

          <Col md={2}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold small">Transport:</Form.Label>
              <Form.Select
                value={transport}
                onChange={(e) => setTransport(e.target.value)}
                className={
                  tema === "dark" ? "bg-dark text-white border-secondary" : ""
                }
              >
                <option value="">Alege tipul...</option>
                <option value="cuTransport">Cu transport</option>
                <option value="faraTransport">Fără transport</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Button
          variant="success"
          type="submit"
          className="w-100 py-2 fw-bold shadow-sm"
        >
          Salvează Partida
        </Button>
      </Form>
    </Container>
  );
};

export default AdaugPartida;
